var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLinhasBola(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 109.025,
    height: 109.025,
    viewBox: "0 0 109.025 109.025",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_707",
    "data-name": "Rectangle 707",
    width: 74,
    height: 74,
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.7
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_706",
    "data-name": "Rectangle 706",
    width: 74.44,
    height: 56.802,
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.7
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2943",
    "data-name": "Group 2943",
    transform: "translate(-141 -2471.527)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 54.513,
    cy: 54.513,
    r: 54.513,
    transform: "translate(141 2471.527)",
    fill: "#f37043"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1114",
    "data-name": "Group 1114",
    transform: "translate(158 2488.758)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1113",
    "data-name": "Group 1113",
    transform: "translate(0 0.242)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1112",
    "data-name": "Group 1112",
    transform: "translate(0.145 8.683)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1111",
    "data-name": "Group 1111",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1110",
    "data-name": "Group 1110"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1109",
    "data-name": "Group 1109",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_388",
    "data-name": "Path 388",
    d: "M1,100.406a1.2,1.2,0,0,0,.215-.168,1.057,1.057,0,0,1,1.3-.34,1.12,1.12,0,0,1,.668,1.175c-.013,3.731-.007,7.462-.005,11.193a5.6,5.6,0,0,0,.038.87,3.375,3.375,0,0,0,3.525,2.982q16.644,0,33.289,0,14.791,0,29.582,0a3.41,3.41,0,0,0,3.642-3.627q.01-17.844,0-35.687c0-.19-.019-.379-.034-.659h-.8c-3.3,0-6.59,0-9.885,0-.764,0-1.191-.4-1.2-1.056-.013-.681.443-1.107,1.218-1.134.169-.006.339,0,.509,0H73.213c.016-.246.042-.454.043-.663,0-1.938.007-3.876,0-5.815a3.427,3.427,0,0,0-3.7-3.715H9.957a6.232,6.232,0,0,1-.8-.015,1.127,1.127,0,0,1-1.024-1.127A1.1,1.1,0,0,1,9.206,61.55c.192-.018.387-.012.581-.012q29.837,0,59.673,0a5.583,5.583,0,0,1,5.961,5.483q.03,22.931.011,45.863a5.532,5.532,0,0,1-5.06,5.415c-.386.028-.774.037-1.161.037q-31,0-62,0c-3.308,0-5.119-1.321-6.116-4.455-.013-.04-.064-.068-.1-.1V100.406",
    transform: "translate(-0.998 -61.536)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    d: "M1,72.347a7.08,7.08,0,0,1,1.637-2.926c.69-.655,1.327-.749,1.831-.235.487.5.418,1.108-.236,1.762A3.248,3.248,0,0,0,3.2,73.207c-.041,2.3-.014,4.6-.014,7H56.542c.266,0,.535-.016.8.01a1.137,1.137,0,0,1,1.047,1.108,1.1,1.1,0,0,1-1.07,1.067c-.265.019-.533.009-.8.009H3.178v.924q0,9.013.005,18.027c0,.618-.05,1.17-.726,1.426s-1.089-.144-1.46-.623Z",
    transform: "translate(-0.998 -67.79)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    d: "M144.564,201.532c1.944,2.354,3.85,4.639,5.721,6.952a1.766,1.766,0,0,1,.441,1.148,1.357,1.357,0,0,1-.747.855,1.059,1.059,0,0,1-1.267-.447c-1.147-1.406-2.307-2.8-3.462-4.2-.925-1.119-1.856-2.232-2.774-3.357-.639-.784-.644-1.142-.011-1.911q3.112-3.783,6.24-7.554a1.169,1.169,0,0,1,1.656-.3,1.112,1.112,0,0,1,.041,1.724q-2.741,3.336-5.5,6.66c-.106.128-.205.261-.339.432",
    transform: "translate(-121.454 -173.413)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    d: "M317.044,201.473c-1.926-2.332-3.8-4.606-5.682-6.881a4.218,4.218,0,0,1-.353-.459,1.044,1.044,0,0,1,.2-1.436,1.081,1.081,0,0,1,1.506.087c.539.587,1.032,1.217,1.541,1.832q2.429,2.935,4.853,5.874c.657.8.659,1.164,0,1.97q-3.069,3.724-6.148,7.44c-.546.66-1.239.79-1.756.346s-.507-1.09.071-1.79c1.909-2.311,3.82-4.621,5.773-6.982",
    transform: "translate(-265.678 -173.364)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    "data-name": "Path 392",
    d: "M233.494,193.812a6.041,6.041,0,0,1-.227.616q-3.593,7.644-7.212,15.276a1.645,1.645,0,0,1-.888.835,1.173,1.173,0,0,1-1.049-.372,1.581,1.581,0,0,1-.075-1.265c.82-1.882,1.721-3.729,2.6-5.587q2.316-4.918,4.631-9.837c.226-.482.477-.9,1.088-.921a1.091,1.091,0,0,1,1.137,1.255",
    transform: "translate(-191.468 -173.47)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    d: "M316,395.369c1.718,0,3.438-.04,5.153.029a1.828,1.828,0,0,1,1.179.637,1.1,1.1,0,0,1-.065,1.042,1.478,1.478,0,0,1-1.031.523c-3.508.038-7.017.032-10.525.016a1.126,1.126,0,0,1-1.259-1.116c0-.679.491-1.12,1.323-1.126,1.742-.013,3.484,0,5.227,0",
    transform: "translate(-264.513 -346.728)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    d: "M273.083,359.321c1.671,0,3.341,0,5.012,0,.835,0,1.317.424,1.309,1.116-.008.664-.467,1.072-1.272,1.073q-5.085.012-10.169,0c-.829,0-1.34-.447-1.327-1.11s.53-1.078,1.362-1.081c1.695,0,3.39,0,5.084,0",
    transform: "translate(-227.939 -315.94)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M169.671,397.675c-1.09,0-2.179.007-3.269,0-.91-.008-1.483-.475-1.455-1.162.027-.668.571-1.087,1.452-1.09q3.305-.009,6.611,0c.881,0,1.427.42,1.455,1.087.029.687-.544,1.157-1.453,1.165-1.114.01-2.228,0-3.342,0",
    transform: "translate(-141.063 -346.779)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    d: "M124.739,361.511c-1.235,0-2.47.01-3.7,0-.789-.009-1.251-.435-1.243-1.1s.48-1.084,1.265-1.086q3.705-.01,7.41,0a1.148,1.148,0,0,1,1.3,1.073c.018.673-.482,1.109-1.318,1.116-1.235.011-2.47,0-3.7,0",
    transform: "translate(-102.485 -315.936)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    d: "M101.834,397.645c-.75,0-1.5.021-2.25-.006a1.129,1.129,0,1,1,.022-2.242q2.249-.027,4.5,0c.794.009,1.26.435,1.274,1.1.015.686-.462,1.126-1.3,1.15-.749.021-1.5,0-2.25,0",
    transform: "translate(-84.158 -346.75)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    d: "M56.457,359.3c.774,0,1.549-.008,2.323,0a1.145,1.145,0,0,1,1.269,1.1,1.108,1.108,0,0,1-1.205,1.083q-2.359.023-4.718,0a1.086,1.086,0,0,1-1.15-1.054,1.1,1.1,0,0,1,1.158-1.126c.774-.02,1.548,0,2.323,0",
    transform: "translate(-45.404 -315.92)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    d: "M97.093,99.881a2.014,2.014,0,0,1-2.04,2.007,2.088,2.088,0,0,1-2.014-2.064,2.052,2.052,0,0,1,2.071-1.992,1.981,1.981,0,0,1,1.983,2.05",
    transform: "translate(-79.63 -92.544)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    d: "M52.6,97.831a2.036,2.036,0,0,1,2.038,2.021,2.067,2.067,0,0,1-2.038,2.036,2.028,2.028,0,0,1-2.019-2.036A1.994,1.994,0,0,1,52.6,97.831",
    transform: "translate(-43.361 -92.544)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    d: "M139.845,99.873a2.029,2.029,0,1,1-2.011-2.039,2.02,2.02,0,0,1,2.011,2.039",
    transform: "translate(-116.152 -92.546)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    d: "M253.605,397.621c-.507,0-1.015.023-1.521,0a1.124,1.124,0,1,1,0-2.239c1.038-.025,2.077-.028,3.115,0a1.118,1.118,0,1,1,0,2.234c-.529.033-1.062.006-1.593.007",
    transform: "translate(-214.455 -346.729)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    d: "M420.952,395.405c.508,0,1.017-.02,1.524.006a1.175,1.175,0,0,1,1.206,1.111,1.155,1.155,0,0,1-1.191,1.123c-1.039.034-2.081.035-3.12,0a1.082,1.082,0,0,1-1.175-1.11c0-.675.444-1.1,1.233-1.129.507-.02,1.016,0,1.524,0",
    transform: "translate(-357.42 -346.763)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    d: "M211.562,359.3c.508,0,1.018-.021,1.525,0a1.074,1.074,0,0,1,1.075,1.125,1.022,1.022,0,0,1-1.065,1.048q-1.633.039-3.268,0a1.075,1.075,0,0,1-1.061-1.072,1.107,1.107,0,0,1,1.05-1.095c.579-.032,1.162-.007,1.743-.008",
    transform: "translate(-178.502 -315.915)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.7
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinhasBola);
export default __webpack_public_path__ + "static/media/icon-linhas-bola.0575061b22fad916bd89aa8de381740f.svg";
export { ForwardRef as ReactComponent };